// @flow
import { createTheme } from '@material-ui/core';

// Shared Material-UI theme. src/index.jsx wraps <App /> in a ThemeProvider using
// this object at runtime; src/test-utils.jsx applies the same one under test so
// rendered components read identical breakpoints and typography variants.

const defaultTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 846,
      xl: 1200,
    },
  },
});

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 846,
      xl: 1200,
    },
  },
  palette: {
    background: {
      paper: '#eee',
      default: '#eee',
    },
  },
  tabNavigation: {
    backgroundColor: '#eee',
  },
  typography: {
    fontFamily: 'RealBook, Helvetica, Arial, sans-serif',
    h1: {
      color: '#003764',
      fontWeight: 500,
      fontSize: '30px',
      [defaultTheme.breakpoints.up('lg')]: {
        fontSize: '40px',
      },
    },
    h2: {
      color: '#003764',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '30px',
      [defaultTheme.breakpoints.up('lg')]: {
        fontSize: '25px',
        lineHeight: '30px',
      },
    },
    subtitle1: {
      color: '#003764',
      fontSize: '15px',
      lineHeight: '20px',
      [defaultTheme.breakpoints.up('lg')]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
    subtitle2: {
      color: '#7B7D82',
      fontSize: '14px',
      lineHeight: '16px',
      fontWeight: 500,
      fontStyle: 'normal',
      letterSpacing: '1px',
      [defaultTheme.breakpoints.up('lg')]: {
        fontSize: '15px',
        lineHeight: '16px',
      },
    },
    body1: {
      color: '#7B7D82',
      fontSize: '15px',
      lineHeight: '22px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      [defaultTheme.breakpoints.up('lg')]: {
        fontSize: '16px',
        lineHeight: '22px',
      },
    },
    link: {
      color: '#13A970',
    },
  },
});

export { theme, defaultTheme };
export default theme;
